export default "__VITE_ASSET__Xe7l12nT__"